import { EXTERNAL_PASSPORT_APP_DOMAIN_NAME } from "../constants/externalSiteConstants";
var isSiteExternal = function() {
    var url = window.location.href;
    return url.includes(EXTERNAL_PASSPORT_APP_DOMAIN_NAME);
};
export default isSiteExternal;

//# sourceMappingURL=isSiteExternal.js.map